import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { FormGroup, FormControl } from '@angular/forms';
import { IPRUpdatesModel } from 'src/Models/IPRUpdatesModel';
import { FavouriteActionItemModel, FavouriteCarrierCategoryModel, stateMasterModel } from 'src/Models/TracItModel';
import { ActionItemService } from 'src/Services/tracit.service';
import { CheckAuth } from 'src/Services/utility.service';
import { AppConfig } from 'src/Services/app.config';
import { ToolEnum } from 'src/Models/Common';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-tracit-my-favorites',
  templateUrl: './my-favorites.component.html',
  styleUrls: ['./my-favorites.component.css']
})
export class TractItActionItemsMyFavoritesComponent implements OnInit {

  userID: number = 0;
  appModel: any;
  isloading: boolean = false;
  tokenKey: string = '';
  favouriteCarrierModel: IPRUpdatesModel[] = [];
  favouriteStateModel: stateMasterModel[] = [];
  favouriteActionItemModel: FavouriteActionItemModel[] = [];
  favouriteCarrierCategoryModel: FavouriteCarrierCategoryModel[] = []
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  carrierForm: FormGroup;
  baseUrl: string;

  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  stateFilter: string = '';
  dropdownSettingsCarrierCategory = {};
  dropdownListActionItemTypes = [];
  dropdownListCarrierCategory = [];
  dropdownSettingsActionItemTypes = {};
  selectedActionItemTypes = [];
  selectedCarrierCategory = [];
  listOfstateID: string[] = [];
  ClientSelectedTool: string;
  ValidationMessage: string;
  DeSelectedFavoriteId: number;
  FavoriteType: string;
  IsDeselected: number = 0;
  isStateRecordsExists: boolean = true;
  isProviderRecordsExists: boolean = true;
  productId: number;

  isStateDropdownLoad: boolean = false;
  isActionItemTypesDropdownLoad: boolean = false;
  isCarrierCategoryDropdownLoad: boolean = false;

  tracItUnreadflag: boolean = true;
  tracItUnread: number = 0;

  constructor(@Inject('BASE_URL') baseUrl: string,
    private readonly toastr: ToastrService,
    private readonly titleService: Title,
    private readonly checkAuth: CheckAuth,
    private readonly actionItemService: ActionItemService,
    private sessionStorageService: SessionStorageService
  ) {
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');
    this.appModel = AppConfig.settings.ConnectionStrings;
    this.carrierForm = new FormGroup({
      stateId: new FormControl(),
      actionItemTypeId: new FormControl(),
      carrierCategoryId: new FormControl(),
    });
    this.ClientSelectedTool = sessionStorage.getItem('ClientLoginTool');
    this.productId = ToolEnum.actionitem;
    this.titleService.setTitle('My Favorites | JSi360');

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    this.tracItUnreadflag = true;
    let tracItReadflag = sessionStorage.getItem('tracItUnreadflag');
    this.tracItUnreadflag = tracItReadflag === 'true' ? true : false;

    let tracItUnreadcount = sessionStorage.getItem('tracItUnread');

    this.tracItUnread = parseInt(tracItUnreadcount);

    this.movetotop();
    this.isloading = false;
    this.ActionTypes();
    this.GetStateData();
    this.GetCarrierCatData();
  }


  ngOnInit() {

  }

  // Action Item Type Methods
  ActionTypes(): void {
    this.isloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    if (!this.isActionItemTypesDropdownLoad)
      this.dropdownListActionItemTypes = [];
    this.actionItemService.GetActionItemTypesFavoriteData(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["result"] != null && data["status"] != "Failure") {
          if (!this.isActionItemTypesDropdownLoad) {
            this.selectedActionItemTypes = [];
            for (let iCounter = 0; iCounter < data["result"].objActionItemsTypeModel.length; iCounter++) {
              this.dropdownListActionItemTypes.push(
                { "id": data["result"].objActionItemsTypeModel[iCounter].actionItemTypeId, "itemName": data["result"].objActionItemsTypeModel[iCounter].typeName }
              );
            }

            for (let iCounter = 0; iCounter < data["result"].objActionItemTypesFavoriteModel.length; iCounter++) {
              this.selectedActionItemTypes.push({ "id": data["result"].objActionItemTypesFavoriteModel[iCounter].actionItemTypeId, "itemName": data["result"].objActionItemTypesFavoriteModel[iCounter].typeName });
            }
          }
          this.favouriteActionItemModel = data["result"].objActionItemTypesFavoriteModel.filter(
            book => book.isDefaultChecked === true);

        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsActionItemTypes = {
          singleSelection: false,
          text: "Select Category(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No Category Available',
          showCheckbox: true,
          enableFilterSelectAll: false,
          enableCheckAll: true
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  onSelectAllActionItemType($event) {
    let stateIds: string = '';
    if ($event) {
      $event.map(x => {
        stateIds += String(x.id) + ',';
      });
      stateIds += "-99";
    }
    this.IsDeselected = 0;
    this.SaveFavoriteActionItem(stateIds, 1);
  }

  onDeSelectAllActionItemType($event) {
    if (this.favouriteActionItemModel != null) {
      let stateIds: string = '';
      this.favouriteActionItemModel.forEach(x => {
        stateIds += String(x.actionItemTypeId) + ',';
      });
      stateIds += "-99";
      this.IsDeselected = 0;
      this.SaveFavoriteActionItem(stateIds, 0);
    }
  }

  OnSelectActionItemType($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteActionItem($event['id'], 1);
  }

  OnDeSelectActionItemType($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteActionItem($event['id'], 0);
  }

  SaveFavoriteActionItem(id: string, IsFavorite: number) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.actionItemService.ActionItemTypeFavouriteAdd(this.tokenKey, this.userID, id, IsFavorite)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (IsFavorite == 1) {
            this.showMessage('Selected category added successfully to favorite list.', 'Favorite', 'success');
          }
          else {
            this.showMessage('Selected category removed successfully from favorite list.', 'Favorite', 'success');
          }

          this.isActionItemTypesDropdownLoad = true;
          this.ActionTypes();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }

      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  GetStateData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.isStateDropdownLoad)
      this.dropdownListState = [];

    this.actionItemService.GetStatesByUserID(this.tokenKey, this.userID, this.productId).subscribe(
      data => {
        if (data["state"] != null) {
          if (!this.isStateDropdownLoad) {
            this.selectedItemsState = [];
            for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
              this.dropdownListState.push(
                { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
              );
              if (data["state"][iCounter].isActionFavorite == true)
                this.selectedItemsState.push({ "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name });
            }
          }
          this.favouriteStateModel = data["state"].filter(
            book => book.isActionFavorite === true);
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "Select Jurisdiction(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No Jurisdiction available',
          showCheckbox: true,
          enableFilterSelectAll: false,
          enableCheckAll: true
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  OnSelectState($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteState($event['id'], 1);
  }
  OnDeSelectState($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteState($event['id'], 0);
  }

  onSelectAllStateList($event) {
    let stateIds: string = '';
    if ($event) {
      $event.map(x => {
        stateIds += String(x.id) + ',';
      });
      stateIds += "-99";
    }
    this.IsDeselected = 0;
    this.SaveFavoriteState(stateIds, 1);
  }

  onDeSelectAllStateList($event) {
    if (this.favouriteStateModel != null) {
      let stateIds: string = '';
      this.favouriteStateModel.forEach(x => {
        stateIds += String(x.stateId) + ',';
      });
      stateIds += "-99";
      this.IsDeselected = 0;
      this.SaveFavoriteState(stateIds, 0);
    }
  }

  SaveFavoriteState(ids: string, IsFavorite: number) {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    this.actionItemService.ActionItemStateFavouriteAdd(this.tokenKey, this.userID, ids, IsFavorite)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (IsFavorite == 1) {
            this.showMessage('Selected Jurisdiction added successfully to favorite list.', 'Favorite', 'success');
          }
          else {
            this.showMessage('Selected Jurisdiction removed successfully from favorite list.', 'Favorite', 'success');
          }

          this.isStateDropdownLoad = true;
          this.GetStateData();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }

      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  //State

  // Carrier Category Methods
  GetCarrierCatData(): void {
    this.isloading = true;
    this.tokenKey = this.sessionStorageService.getTokenValue();
    if (!this.isCarrierCategoryDropdownLoad)
      this.dropdownListCarrierCategory = [];
    this.actionItemService.GetCarrierCategoryFavoriteData(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["result"] != null && data["status"] != "Failure") {
          if (!this.isCarrierCategoryDropdownLoad) {
            this.selectedCarrierCategory = [];
            for (let iCounter = 0; iCounter < data["result"].objCarrierCategoryModel.length; iCounter++) {
              this.dropdownListCarrierCategory.push(
                { "id": data["result"].objCarrierCategoryModel[iCounter].carrierCatId, "itemName": data["result"].objCarrierCategoryModel[iCounter].carrierCatName }
              );
            }

            for (let iCounter = 0; iCounter < data["result"].objCarrierCategoryFavoriteModel.length; iCounter++) {
              this.selectedCarrierCategory.push({ "id": data["result"].objCarrierCategoryFavoriteModel[iCounter].carrierCatId, "itemName": data["result"].objCarrierCategoryFavoriteModel[iCounter].carrierCatName });
            }
          }

          this.favouriteCarrierCategoryModel = data["result"].objCarrierCategoryFavoriteModel;

        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsCarrierCategory = {
          singleSelection: false,
          text: "Select Carrier Type(s)",
          enableSearchFilter: true,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No Carrier Type Available',
          showCheckbox: true,
          enableFilterSelectAll: false,
          enableCheckAll: true
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  OnSelectCarrierCategory($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteCarrierCategory($event['id'], 1);
  }
  OnDeSelectCarrierCategory($event) {
    this.IsDeselected = 0;
    this.SaveFavoriteCarrierCategory($event['id'], 0);
  }

  onSelectAllCarrierCategory($event) {
    let stateIds: string = '';
    if ($event) {
      $event.map(x => {
        stateIds += String(x.id) + ',';
      });
      stateIds += "-99";
    }
    this.IsDeselected = 0;
    this.SaveFavoriteCarrierCategory(stateIds, 1);
  }

  onDeSelectAllCarrierCategory($event) {
    if (this.favouriteCarrierCategoryModel != null) {
      let stateIds: string = '';
      this.favouriteCarrierCategoryModel.forEach(x => {
        stateIds += String(x.carrierCatId) + ',';
      });
      stateIds += "-99";
      this.IsDeselected = 0;
      this.SaveFavoriteCarrierCategory(stateIds, 0);
    }
  }

  SaveFavoriteCarrierCategory(id: string, IsFavorite: number) {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.actionItemService.CarrierCategoryFavouriteAdd(this.tokenKey, this.userID, id, IsFavorite)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (IsFavorite == 1) {
            this.showMessage('Selected carrier type added successfully to favorite list.', 'Favorite', 'success');
          }
          else {
            this.showMessage('Selected carrier type removed successfully from favorite list.', 'Favorite', 'success');
          }

          this.isCarrierCategoryDropdownLoad = true;
          this.GetCarrierCatData();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }

      }, error => {
        this.showMessage(error, 'Error', 'error');
      })
  }

  // End

  DeselectFavourite() {
    this.IsDeselected = 0;

    if (this.FavoriteType == 'state') {
      this.SaveFavoriteState(String(this.DeSelectedFavoriteId), 0);
      this.selectedItemsState = this.removeElemetninArray(this.selectedItemsState, this.DeSelectedFavoriteId);
    }
    else if (this.FavoriteType == 'actionItem') {
      this.SaveFavoriteActionItem(String(this.DeSelectedFavoriteId), 0);
      this.selectedActionItemTypes = this.removeElemetninArray(this.selectedActionItemTypes, this.DeSelectedFavoriteId);
    }
    else if (this.FavoriteType == 'carrierCategory') {
      this.SaveFavoriteCarrierCategory(String(this.DeSelectedFavoriteId), 0);
      this.selectedCarrierCategory = this.removeElemetninArray(this.selectedCarrierCategory, this.DeSelectedFavoriteId);
    }
    document.getElementById("btnClose").click();
  }

  CancelDeselectFavourite() {

    if (this.FavoriteType == 'state' && this.IsDeselected == 1) {
      this.selectedItemsState.push({ "id": this.DeSelectedFavoriteId });
      this.GetStateData();
    }
    else if (this.FavoriteType == 'actionItem' && this.IsDeselected == 1) {
      this.selectedActionItemTypes.push({ "id": this.DeSelectedFavoriteId });
      this.ActionTypes();
    }
    else if (this.FavoriteType == 'carrierCategory' && this.IsDeselected == 1) {
      this.selectedCarrierCategory.push({ "id": this.DeSelectedFavoriteId });
      this.GetCarrierCatData();
    }
  }

  RemoveStarFavorite(id: number, Type: string) {
    this.IsDeselected = 1;
    this.DeSelectedFavoriteId = id;
    if (Type == 'state') {
      this.ValidationMessage = "Are you sure you want to remove selected Jurisdiction from favorite list?"
      this.FavoriteType = 'state';
    }
    else if (Type == 'actionItem') {
      this.ValidationMessage = "Are you sure you want to remove selected category from favorite list?"
      this.FavoriteType = 'actionItem';
    }
    else if (Type == 'carrierCategory') {
      this.ValidationMessage = "Are you sure you want to remove selected carrier type from favorite list?"
      this.FavoriteType = 'carrierCategory';
    }
    var elem = document.getElementById("lnkFavouriteValidation");
    elem.click();
  }
  removeElemetninArray(array, element) {
    return array.filter(e => e.id != element);
  }
  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }
  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }
  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }
  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

}
